export default "__VITE_ASSET__CkaS7eiX__"